import React from 'react';

import { Box, Button, Flex, Heading, Text } from '@opendoor/bricks/core';

interface IDownloadAppProps {
  handleOnNext: () => void;
}

/**
 * Download app step
 *
 * storybook-check-ignore
 */
export const DownloadApp: React.FC<IDownloadAppProps> = ({ handleOnNext }) => {
  return (
    <Flex alignItems="center" flexDirection="column" gridGap="3">
      <Box mb={5}>
        <Heading size="UNSAFE_h2" as="h2" mb={3}>
          Get the app to tour this home
        </Heading>
      </Box>
      <Text>Tour any day from 8:00am to 7:30pm. Unlock the door with the Opendoor app.</Text>
      <Button
        type="button"
        variant="primary"
        width={['100%', null, '50%']}
        analyticsName="cake-tour-creation-flow-download-app"
        aria-label="Get the app"
        onClick={handleOnNext}
        mt={3}
      >
        Get the app
      </Button>
    </Flex>
  );
};
